
const SVGSizeChartIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1999 10.2001C14.349 10.3488 14.4674 10.5254 14.5481 10.7199C14.6289 10.9144 14.6705 11.1229 14.6705 11.3334C14.6705 11.544 14.6289 11.7525 14.5481 11.947C14.4674 12.1415 14.349 12.3181 14.1999 12.4668L12.4665 14.2001C12.3179 14.3493 12.1413 14.4676 11.9468 14.5484C11.7523 14.6291 11.5438 14.6707 11.3332 14.6707C11.1226 14.6707 10.9141 14.6291 10.7196 14.5484C10.5251 14.4676 10.3485 14.3493 10.1999 14.2001L1.79987 5.80011C1.50024 5.49903 1.33203 5.09155 1.33203 4.66678C1.33203 4.24201 1.50024 3.83453 1.79987 3.53345L3.5332 1.80011C3.83428 1.50048 4.24177 1.33228 4.66653 1.33228C5.0913 1.33228 5.49879 1.50048 5.79987 1.80011L14.1999 10.2001Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.6665 8.33333L10.9998 7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6665 6.33333L8.99984 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.6665 4.33333L6.99984 3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6665 10.3333L12.9998 9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SVGSizeChartIcon;
